// extracted by mini-css-extract-plugin
export default {"wrapper":"oqk9CBCLTAQLaes244y1","inputTable":"ifPnXsExqFWIoDWdn5K7","newInputTable":"rFvBwd5M9tZEPZDMgi5D","iconWrapper":"qVjChYJFNGaCxrkTPRc6","icon":"J9FVDRXQbxZqV1_LohHS"};